export const environment = {
  production: false,
  environment: 'uat',
  auth: {
    clientId: '1d68f376-331b-45a0-8fb3-275ef28ef9ad',
    authority: 'https://login.microsoftonline.com/76b5b304-4736-44dc-ba8c-944e061047eb',
    redirectUri: 'https://gttest.dnv.org/map',
    logoutUri: 'https://gttest.dnv.org/map',
    piiLoggingEnabled: false,
  },
  webApiUrl: 'https://gttest.dnv.org/',
   syncfusionLicenseKey: 'ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5adkZiUH9ac3FWQWBZWkd+'
};
